import React from "react";
import { useNavigate } from "react-router-dom";
import Topbar from "../components/Topbar";
import Sidebar from "../components/Sidebar";
import styles from "../assets/css/Dashboard.module.css";
import { FaHotel, FaFileAlt } from "react-icons/fa";

function MaaCanteenReport() {
  const navigate = useNavigate();
  const cards = [
    {
      id: 11,
      title: "Maa Canteen (Balurghat Municipality)",
      subtitle: "Primary Location",
      created_by:9,
    },
    {
      id: 12,
      title: "Maa Canteen (District Hospital Campus)",
      subtitle: "Hospital Campus",
      created_by:10,

    },
  ];

  return (
    <>
      <Topbar />
      <div className="d-flex">
        <Sidebar />
        <div className={styles.dashboardContainer}>
          <div className={styles.dashboardContent}>
            <div className="d-flex justify-content-between align-items-center mb-4">
              <h2
                className="mb-0"
                style={{ color: "#2c3e50", fontWeight: "600", fontSize: "1.8rem" }}
              >
                Maa Canteen Report
              </h2>
            </div>

            <div className="row g-4">
              {cards.map((item) => (
                <div key={item.id} className="col-md-6">
                  <div
                    className="card h-100"
                    style={{ borderRadius: "15px", overflow: "hidden", background: "linear-gradient(145deg, #ffffff, #f8f9fa)" }}
                  >
                    <div className="card-body p-4">
                      <div className="d-flex align-items-center mb-4">
                        <div
                          style={{
                            width: "60px",
                            height: "60px",
                            borderRadius: "12px",
                            background: "#1976D2",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            marginRight: "15px",
                            color: "#fff",
                          }}
                        >
                          <FaHotel size={24} />
                        </div>
                        <div>
                          <h5 className="mb-1" style={{ color: "#2c3e50", fontWeight: 600 }}>{item.title}</h5>
                          <div className="text-muted" style={{ fontSize: "0.9rem" }}>{item.subtitle}</div>
                        </div>
                      </div>

                      <div className="d-flex justify-content-end mt-3">
                        <button
                          className="btn btn-primary"
                          style={{
                            background: "#1976D2",
                            border: "none",
                            borderRadius: "8px",
                            padding: "8px 20px",
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                          }}
                          onClick={() => navigate(`/canteendetails/${item.id}/${item.created_by}/${item.title}`)}
                        >
                          <FaFileAlt />
                          View Report
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default MaaCanteenReport;


